import React, { Component, Fragment } from 'react';
import TeamMembersTable from './TeamMembersTable';
import TeamMemberForm from './TeamMemberForm';
import ReactDOM from 'react-dom';

class TeamMembers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMemberForm: false,
        };
    }

    toggleForm = () => {
        this.setState((prevState) => ({
            showMemberForm: !prevState.showMemberForm,
        }));
    };

    render() {
        const { showMemberForm } = this.state;

        return (
            <Fragment>
                <div className="row py-4">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 bg-secondary text-white">Team Members</h6>
                        <TeamMembersTable />
                    </div>
                </div>
                {showMemberForm && <TeamMemberForm />}
                <div className="row">
                    <div className="col-12">
                        <span onClick={this.toggleForm} className="text-primary clickable-span">
                            <i className={showMemberForm ? 'fas fa-minus-square' : 'fas fa-plus-square'}> </i>
                            {showMemberForm ? 'Hide form' : 'Add new team member'}
                        </span>
                    </div>
                </div>
            </Fragment>
        );
    }
}

if (document.getElementById('teamMembers')) {
    let element = document.getElementById('teamMembers');
    ReactDOM.render(<TeamMembers />, element);
}

export default TeamMembers;
